import {useGoogleLogin} from "@react-oauth/google";

import {pick} from "@pg-mono/nodash";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addNotification} from "../../notifications/state/notifications_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {reportAuthSuccess} from "../actions/report_auth_success";
import {facebookAuth, googleAuth} from "../api/social_auth";
import {SocialMediaType} from "../state/registration_flow_slice";
import {AmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../types/AuthActionType";
import type {IFacebookResponse} from "../types/IFacebookResponse";
import {GOOGLE_OAUTH_SCOPE} from "../utils/social_auth_config";

interface IUseSocialAuthParams {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation: AmplitudeAuthLocation;
    authPlacement?: AmplitudeAuthPlacement | null;
}

type SocialAuthResponse = Awaited<ReturnType<typeof googleAuth>>;

const socialAuthFailureNotification = {type: "failure", content: "Coś poszło nie tak. Spróbuj później."} as const;

const socialAuthProviderNames: Record<SocialMediaType, string> = {
    google: "Google",
    facebook: "Facebook"
};

const getSocialAuthActionType = (socialMediaType: SocialMediaType, authResponse: SocialAuthResponse): AuthActionType => {
    if (typeof authResponse.is_new !== "boolean") {
        notifyBugsnag(new Error("Problem with social auth response"), `Problem with is_new type in ${socialAuthProviderNames[socialMediaType]} Auth response`, {
            ...pick(authResponse, ["type", "login_method", "is_new"])
        });
    }

    return authResponse.is_new ? AuthActionType.REGISTRATION : AuthActionType.LOGIN;
};

export const useSocialAuth = (params: IUseSocialAuthParams) => {
    const {onAuthSuccess, userSource, gtmSourceSection, amplitudePlacement, amplitudeLocation, authPlacement} = params;
    const dispatch = useAppDispatch();

    const notifySocialAuthFailure = () => {
        dispatch(addNotification({notification: socialAuthFailureNotification}));
    };

    const handleSocialAuthResponse = (socialMediaType: SocialMediaType) => async (authResponse: SocialAuthResponse) => {
        const authActionType = getSocialAuthActionType(socialMediaType, authResponse);

        reportAuthSuccess(
            dispatch,
            {
                method: socialMediaType,
                authActionType,
                userSource,
                gtmSourceSection,
                placement: amplitudePlacement ?? null,
                location: amplitudeLocation,
                authPlacement
            },
            {registrationMethod: "social", socialMediaType}
        );

        onAuthSuccess(authActionType);
    };

    const startGoogleLogin = useGoogleLogin({
        onError: () => {
            notifySocialAuthFailure();
        },
        onNonOAuthError: async (error) => {
            if (error.type === "popup_closed") {
                return;
            }
            notifySocialAuthFailure();
        },
        onSuccess: (response) => {
            if (response.access_token) {
                googleAuth(response.access_token).then(handleSocialAuthResponse("google"), notifySocialAuthFailure);
            }
        },
        scope: GOOGLE_OAUTH_SCOPE
    });

    const handleFacebookResponse = (response: IFacebookResponse) => {
        facebookAuth(response.accessToken).then(handleSocialAuthResponse("facebook"), notifySocialAuthFailure);
    };

    return {startGoogleLogin, handleFacebookResponse};
};
import {useGoogleLogin} from "@react-oauth/google";

import {pick} from "@pg-mono/nodash";

import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {addNotification} from "../../notifications/state/notifications_slice";
import {useAppDispatch} from "../../store/hooks";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../tracking/types/AmplitudeAuthPlacement";
import {reportAuthSuccess} from "../actions/report_auth_success";
import {facebookAuth, googleAuth} from "../api/social_auth";
import {SocialMediaType} from "../state/registration_flow_slice";
import {AmplitudeAuthLocation} from "../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../types/AuthActionType";
import type {IFacebookResponse} from "../types/IFacebookResponse";
import {GOOGLE_OAUTH_SCOPE} from "../utils/social_auth_config";

interface IUseSocialAuthParams {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation: AmplitudeAuthLocation;
    authPlacement?: AmplitudeAuthPlacement | null;
}

type SocialAuthResponse = Awaited<ReturnType<typeof googleAuth>>;

const socialAuthFailureNotification = {type: "failure", content: "Coś poszło nie tak. Spróbuj później."} as const;

const socialAuthProviderNames: Record<SocialMediaType, string> = {
    google: "Google",
    facebook: "Facebook"
};

const getSocialAuthActionType = (socialMediaType: SocialMediaType, authResponse: SocialAuthResponse): AuthActionType => {
    if (typeof authResponse.is_new !== "boolean") {
        notifyBugsnag(new Error("Problem with social auth response"), `Problem with is_new type in ${socialAuthProviderNames[socialMediaType]} Auth response`, {
            ...pick(authResponse, ["type", "login_method", "is_new"])
        });
    }

    return authResponse.is_new ? AuthActionType.REGISTRATION : AuthActionType.LOGIN;
};

export const useSocialAuth = (params: IUseSocialAuthParams) => {
    const {onAuthSuccess, userSource, gtmSourceSection, amplitudePlacement, amplitudeLocation, authPlacement} = params;
    const dispatch = useAppDispatch();

    const notifySocialAuthFailure = () => {
        dispatch(addNotification({notification: socialAuthFailureNotification}));
    };

    const handleSocialAuthResponse = (socialMediaType: SocialMediaType) => async (authResponse: SocialAuthResponse) => {
        const authActionType = getSocialAuthActionType(socialMediaType, authResponse);

        reportAuthSuccess(
            dispatch,
            {
                method: socialMediaType,
                authActionType,
                userSource,
                gtmSourceSection,
                placement: amplitudePlacement ?? null,
                location: amplitudeLocation,
                authPlacement
            },
            {registrationMethod: "social", socialMediaType}
        );

        onAuthSuccess(authActionType);
    };

    const startGoogleLogin = useGoogleLogin({
        onError: () => {
            notifySocialAuthFailure();
        },
        onNonOAuthError: async (error) => {
            if (error.type === "popup_closed") {
                return;
            }
            notifySocialAuthFailure();
        },
        onSuccess: (response) => {
            if (response.access_token) {
                googleAuth(response.access_token).then(handleSocialAuthResponse("google"), notifySocialAuthFailure);
            }
        },
        scope: GOOGLE_OAUTH_SCOPE
    });

    const handleFacebookResponse = (response: IFacebookResponse) => {
        facebookAuth(response.accessToken).then(handleSocialAuthResponse("facebook"), notifySocialAuthFailure);
    };

    return {startGoogleLogin, handleFacebookResponse};
};
